import moment from 'moment';
import { useMemo } from 'react';
import { formatMoneyWithCurrency } from 'src/utils/formatter';

export function GetLabels({ source, period, specificPeriods }) {
    if (!source) return []

    if (period === 'year') return source.reduce((acc, el) => {
        const [month] = el.label.split('-')
        const monthName = month.toUpperCase()
        if (acc.includes(monthName)) return acc

        acc.push(monthName.toUpperCase())
        return acc
    },[])

    if (period === 'semester') return source.reduce((acc, el, index) => {
        const [month] = el.label.split('-')
        const monthName = month.toUpperCase()
        if (acc.includes(monthName)) return acc

        if (specificPeriods == 'firstSemester' && [0, 1, 2, 3, 4 , 5].includes(index)) acc.push(monthName.toUpperCase())
        if (specificPeriods == 'secondSemester' && [6, 7, 8, 9, 10 , 11].includes(index)) acc.push(monthName.toUpperCase())
        return acc
    },[])

    if (period === 'quarter') return source.reduce((acc, el, index) => {
        const [month] = el.label.split('-')
        const monthName = month.toUpperCase()
        if (acc.includes(monthName)) return acc

        if (specificPeriods == 'firstQuarter' && [0, 1, 2].includes(index)) acc.push(monthName.toUpperCase())
        if (specificPeriods == 'secondQuarter' && [3, 4, 5].includes(index)) acc.push(monthName.toUpperCase())
        if (specificPeriods == 'thirdQuarter' && [6, 7, 8].includes(index)) acc.push(monthName.toUpperCase())
        if (specificPeriods == 'fourthQuarter' && [9, 10, 11].includes(index)) acc.push(monthName.toUpperCase())

        return acc
    },[])
}

export function GetDataset({ source, period, specificPeriods, hidden = false, isPast = false }) {
    if (!source) return {
        backgroundColor: Array.from({ length: 12 }, (_, i) => "#9743F2"),
        hidden: false,
        label: Array.from({ length: 12 }, (_, i) => moment().startOf('year').add(i, 'month').format('MMM-YYYY').replace(/\./g, "")),
        data: Array.from({ length: 12 }, (_, i) => 0),
    }

    const completeSet = {
        backgroundColor: Array.from({ length: 12 }, (_, i) => isPast ? "#9743F2" : "#0099ff"),
        hidden,
        label: source.map(el => el.label),
        data: source.map(el => el.sales),
    }

    if (period === 'year') return completeSet
    if (period === 'semester') {
        if (specificPeriods == 'firstSemester') return {
            ...completeSet,
            backgroundColor: completeSet.backgroundColor.slice(0, 6),
            label: completeSet.label.slice(0, 6),
            data: completeSet.data.slice(0, 6),
        }

        if (specificPeriods == 'secondSemester') return {
            ...completeSet,
            backgroundColor: completeSet.backgroundColor.slice(6, 12),
            label: completeSet.label.slice(6, 12),
            data: completeSet.data.slice(6, 12),
        }

        return completeSet
    }

    if (period === 'quarter') {
        if (specificPeriods == 'firstQuarter') return {
            ...completeSet,
            backgroundColor: completeSet.backgroundColor.slice(0, 3),
            label: completeSet.label.slice(0, 3),
            data: completeSet.data.slice(0, 3),
        }

        if (specificPeriods == 'secondQuarter') return {
            ...completeSet,
            backgroundColor: completeSet.backgroundColor.slice(3, 6),
            label: completeSet.label.slice(3, 6),
            data: completeSet.data.slice(3, 6),
        }

        if (specificPeriods == 'thirdQuarter') return {
            ...completeSet,
            backgroundColor: completeSet.backgroundColor.slice(6, 9),
            label: completeSet.label.slice(6, 9),
            data: completeSet.data.slice(6, 9),
        }

        if (specificPeriods == 'fourthQuarter') return {
            ...completeSet,
            backgroundColor: completeSet.backgroundColor.slice(9, 12),
            label: completeSet.label.slice(9, 12),
            data: completeSet.data.slice(9, 12),
        }

        return completeSet
    }
}

export function GetAccumulateAmount({ source, isPast = false }) {
    const [startPeriod, year] = source.label[0].split('-')
    const [endPeriod] = source.label[source.label.length - 1].split('-')

    const completeSet = {
        header: year != 'yyyy' ? `PERIODO ${year}` : '',
        content: "$ 0",
        footer: startPeriod != '000' && startPeriod != '000' ? `${startPeriod.toUpperCase()} - ${endPeriod.toUpperCase()}` : '',
        isBack: isPast
    }

    const total = Math.round(source.data.reduce((acc, el) => acc + el, 0) * 1000000)
    const content = formatMoneyWithCurrency(total)
    return {
        ...completeSet,
        content,
    }
}

export function GetCurrentAmount({ source, isPast = false }) {
    const { label, sales } = source[moment().month()]

    const header = label != '000-yyyy' ? label.replace('-', ' ').replace(/[^A-Za-z0-9\s]/g, "").toUpperCase() : ''

    const completeSet = {
        header,
        content: "$ 0",
        isBack: isPast
    }

    const total = Math.round(sales * 1000000)
    const content = formatMoneyWithCurrency(total)
    return {
        ...completeSet,
        content,
    }
}

export function GetPorcentage({ data }) {

    const completeSet = {
        porcentage: String(0).replace('.', ','),
        footer: "Periodos 2022 - 2023",
    }
    const lastPeriod = GetAccumulateAmount({ source: data[0] })
    const currentPeriod = GetAccumulateAmount({ source: data[1] })
    const cleanCurrentAmount = currentPeriod.content.replace(/[^0-9-]/g, '')
    const cleanLastAmount = lastPeriod.content.replace(/[^0-9-]/g, '')

    const lastLabels = data[0].label
    const currentLabels = data[1].label

    const getFooter = (arr) => {

        const firstLabel = arr[0]
        const lastLabel = arr[arr.length - 1]

        if (firstLabel == '000-yyyy' && lastLabel == '000-yyyy') return '';

        const [startPeriod, year] = firstLabel.split('-')
        const [endPeriod] = lastLabel.split('-')

        return `${startPeriod.toUpperCase()} - ${endPeriod.toUpperCase()} ${year}`
    }

    const firstPeriod = getFooter(lastLabels);
    const SecondPeriod = getFooter(currentLabels);

    const footer = firstPeriod && SecondPeriod ? `${getFooter(lastLabels)} / ${getFooter(currentLabels)}` : '';
    const porcentage = cleanLastAmount == 0 ? 0 : ((cleanCurrentAmount / (cleanLastAmount || 0.5)) - 1) * 100

    return {
        ...completeSet,
        porcentage: String(porcentage.toFixed(1)).replace('.', ','),
        footer,
    }
}

